import request from 'tools/request'

export const getMotusDotSearches = async (applicationId, pagination = {}) => {
    return await request(
        `motus/dot/searches`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-pagination-sort': 'createdAt,desc'
        },
        { applicationUuid: applicationId }
    )
}

export const getMotusNameSearches = async (applicationId, pagination = {}) => {
    return await request(
        `motus/name/searches`,
        'GET',
        null,
        true,
        {
            'x-pagination-num': pagination.page || 0,
            'x-pagination-limit': pagination.limit || 5,
            'x-pagination-sort': 'createdAt,desc'
        },
        { applicationUuid: applicationId }
    )
}

export const getMotusDotSearchDetail = async (searchUuid) => {
    return await request(
        `motus/dot/searches/${searchUuid}`,
        'GET'
    )
}

export const getMotusNameSearchDetail = async (searchUuid) => {
    return await request(
        `motus/name/searches/${searchUuid}`,
        'GET'
    )
}

export const performMotusDotSearch = async (applicationId, payload) => {
    return await request(
        `applications/${applicationId}/motus/dot`,
        'POST',
        payload
    )
}

export const performMotusNameSearch = async (applicationId, payload) => {
    return await request(
        `applications/${applicationId}/motus/name`,
        'POST',
        payload
    )
}

export const getSearchedDotNumbers = async (applicationId) => {
    return await request(
        `applications/${applicationId}/motus/dot/searched`,
        'GET'
    )
}

export const searchMotusByDot = async (payload) => {
    return await request(
        `motus/dot`,
        'POST',
        payload
    )
}

export const searchMotusByName = async (payload) => {
    return await request(
        `motus/name`,
        'POST',
        payload
    )
}